import styled from 'styled-components'

import { StyledInputWrapper } from 'components/DatePicker/DatePickerStyled'

export const StyledDatePicker = styled.div`
  & > div > div > div {
    display: flex;

    ${StyledInputWrapper} {
      min-width: 260px;
    }
  }
`
